// const defaultApiUrl = "https://api-develop.informez-moi.fr";
const defaultApiUrl = "http://localhost:1337";

// eslint-disable-next-line import/prefer-default-export
export const Constants = {
  // App
  DEDICATED_APP: parseInt(import.meta.env.VITE_IS_DEDICATED_APP, 10) === 1,
  IS_LOGIN_MANDATORY_APP: import.meta.env.VITE_IS_LOGIN_MANDATORY_APP
    ? import.meta.env.VITE_IS_LOGIN_MANDATORY_APP.toLowerCase() === "true"
    : false,

  // Backoffice
  TEMPLATE: import.meta.env.VITE_TEMPLATE,
  IS_MULTI_ORGANIZATIONS: import.meta.env.VITE_IS_MULTI_ORGANIZATIONS
    ? import.meta.env.VITE_IS_MULTI_ORGANIZATIONS.toLowerCase() === "true"
    : false,

  IS_ACCESS_REQUESTS_ENABLED: import.meta.env.VITE_IS_ACCESS_REQUESTS_ENABLED
    ? import.meta.env.VITE_IS_ACCESS_REQUESTS_ENABLED.toLowerCase() === "true"
    : false,

  ARE_ORGANIZATIONS_PROTECTED: import.meta.env.VITE_ARE_ORGANIZATIONS_PROTECTED
    ? import.meta.env.VITE_ARE_ORGANIZATIONS_PROTECTED.toLowerCase() === "true"
    : true,

  DISPLAY_IS_TEST_PLATFORM: import.meta.env.VITE_DISPLAY_IS_TEST_PLATFORM
    ? import.meta.env.VITE_DISPLAY_IS_TEST_PLATFORM.toLowerCase() === "true"
    : false,

  IS_MAP_ENABLED: import.meta.env.VITE_IS_MAP_ENABLED
    ? import.meta.env.VITE_IS_MAP_ENABLED.toLowerCase() === "true"
    : false,

  MAP_DEFAULT_LAT: import.meta.env.VITE_MAP_DEFAULT_LAT
    ? import.meta.env.VITE_MAP_DEFAULT_LAT
    : 43.6043,

  MAP_DEFAULT_LNG: import.meta.env.VITE_MAP_DEFAULT_LNG
    ? import.meta.env.VITE_MAP_DEFAULT_LNG
    : 1.4437,

  IS_THREADS_MAP_ENABLED: import.meta.env.VITE_IS_THREADS_MAP_ENABLED
    ? import.meta.env.VITE_IS_THREADS_MAP_ENABLED.toLowerCase() === "true"
    : false,

  IS_SMS_ACTIVE: import.meta.env.VITE_IS_SMS_ACTIVE
    ? import.meta.env.VITE_IS_SMS_ACTIVE.toLowerCase() === "true"
    : true,

  ANONYMOUS_USER_ACTIVE: import.meta.env.VITE_ANONYMOUS_USER_ACTIVE
    ? import.meta.env.VITE_ANONYMOUS_USER_ACTIVE.toLowerCase() === "true"
    : false,

  DISPLAY_STORE_STATS: import.meta.env.VITE_DISPLAY_STORE_STATS
    ? import.meta.env.VITE_DISPLAY_STORE_STATS.toLowerCase() === "true"
    : false,

  IS_USERZONE_ENABLED: import.meta.env.VITE_IS_USERZONE_ENABLED
    ? import.meta.env.VITE_IS_USERZONE_ENABLED.toLowerCase() === "true"
    : false,

  // Login
  ENABLE_LOGIN: import.meta.env.VITE_ENABLE_LOGIN_OAUTH
    ? import.meta.env.VITE_ENABLE_LOGIN_OAUTH.toLowerCase() === "true"
    : false,
  LOGIN_HOST: import.meta.env.VITE_LOGIN_OAUTH_LABEL ?? "",
  LOGIN_PROVIDER: import.meta.env.VITE_LOGIN_OAUTH_PROVIDER ?? "microsoft",

  // Api
  API_URL: `${
    import.meta.env.VITE_API_URL ?? "https://api-develop.informez-moi.fr"
  }/api`,
  ROOT_URL:
    import.meta.env.VITE_API_URL ?? "https://api-develop.informez-moi.fr",
};
